import { CustomDetailsList, Loader } from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { MultiLanguageNameTable } from "./MultiLanguageNameTable";

export const CategoryGeneralDetails = (props) => {
  const navigate = useNavigate();
  const { state, isEditable, id } = props;
  const columns = React.useMemo(
    () => [
      {
        title: "Display Order",
        accessor: "display_order",
      },
      // {
      //   title: "Report Category",
      //   accessor: "report_category_name",
      // },
      // {
      //   title: "Report Class Name",
      //   accessor: "report_class_name",
      // },

      {
        title: "Description",
        accessor: "description",
        accessor: (row) => {
          return <div>{parse(row?.description ?? "")}</div>;
        },
      },
      {
        title: "Show in List",
        accessor: (row) => {
          return row.show_in_list ? "Yes" : "No";
        },
      },
    ],
    [],
  );

  const multiLanguageColumns = [
    {
      head: "Language",
      accessor: "lang",
      sx: { width: "16%", minWidth: "150px" },
    },
    {
      head: "Category Name",
      accessor: "locale_name",
      sx: { width: "42%" },
    },
    {
      head: "Category Display Name",
      accessor: "locale_display_name",
    },
  ];

  return (
    <>
      {state.product.isBusy ? (
        <Loader />
      ) : (
        <CustomDetailsList
          columns={columns}
          data={state.data}
          title="Basic Informations"
          footer={
            <Stack direction="row" justifyContent="flex-end" p="16px">
              {isEditable && (
                <Button
                  type="button"
                  size="medium"
                  onClick={() => navigate(`/category/details/edit/${id}`)}
                >
                  Edit
                </Button>
              )}
            </Stack>
          }
          customHeader={
            <Stack p="24px" gap="16px">
              <Typography fontSize="16px" fontWeight={600}>
                Multilingual Names
              </Typography>
              <MultiLanguageNameTable
                rowBorder
                columns={multiLanguageColumns}
                data={state.categoryNamings}
                loading={state.categoryNamingsLoading}
              />
            </Stack>
          }
        />
      )}
    </>
  );
};
